import Siema from "siema";
import gaTrackEvent from "../gaTrackEvent";

export default class Static {
  index() {
    window.addEventListener("load", function () {
      const siema = new Siema();
      document
        .querySelector("#testim-prev")
        .addEventListener("click", () => siema.prev());
      document
        .querySelector("#testim-next")
        .addEventListener("click", () => siema.next());
    });
  }

  resources() {
    document.querySelectorAll("a.track-resource-dl").forEach((a) => {
      a.addEventListener("click", (e) => {
        let label = a.href.split("/");
        label = label[label.length - 1];
        label = label.split("-");
        label.pop();
        label = label.join("-").replace(/%20/g, " ");
        gaTrackEvent("resources", "download", label);
      });
    });
  }
}
